<template>
  <v-layout row justify-center>
    <v-dialog v-model="isTextDialogOpen" width="60%" height="40%" persistent>
      <v-card>
        <v-img v-if="imageUrl" height="250" :src="imageUrl"></v-img>

        <lottie
          v-if="lottieUrl"
          :path="lottieUrl"
          :loop="lottieLoop"
          :height="250"
        >
        </lottie>

        <v-card-title class="headline pr-5 pl-5" justify-center>
          {{ title }}
        </v-card-title>

        
        <!-- explication text -->
        <v-card-text
          v-if="explanation && type !== 'publishIncompleteChecklist'"
          class="pr-5 pl-5"
        >
          <p v-html="explanation"></p>
        </v-card-text>

        <!-- delete text field-->
        <v-layout v-if="type === 'deletePath' || type === 'deleteMission'" justify-center mt-4>
          <v-text-field
            style="max-width: 200px"
            :rules="rules[type]"
            outline
            single-line
            v-model="deleteValue"
          />
        </v-layout>

        

        <!-- detail text -->
        <v-card-text v-if="details" class="pr-5" style="padding-left: 80px">
          <p v-html="details"></p>
        </v-card-text>

        <!--v-card-actions-->
        <v-flex layout row pl-2 pr-2>
          <v-btn
            v-if="cancelIsPossible"
            outline
            flat
            color="primary"
            class="text-none"
            @click="cancel"
          >
            {{ cancelButtonText }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :color="confirmButtonColor"
            class="text-none white--text"
            :disabled="isConfirmButtonDisabled"
            @click="confirm"
          >
            {{ confirmButtonText }}
          </v-btn>
        </v-flex>
        <!--/v-card-actions-->
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Lottie from 'lottie-vuejs/src/LottieAnimation.vue';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import CheckList from './CheckList.vue';

export default {
  name: 'textDialog',
  components: {
    Lottie,
    LottieAnimation,
    CheckList,
  },
  data() {
    return {
      rules: {
        deletePath: [
          (delValue) => (delValue === this.deleteText[this.locale])||
            this.$t('managePath.textDialogInformations.delete.error'),
        ],
        deleteMission: [
          (delValue) => (delValue === this.deleteText[this.locale])||
            this.$t('managePath.textDialogInformations.delete.error'),
        ],
      },
      defaultText: {
        confirm: this.$t('managePath.textDialogInformations.default.confirm'),
        cancel: this.$t('managePath.textDialogInformations.default.cancel'),
      },
      deleteText:{fr:"SUPPRIMER",en:"DELETE"},
      deleteValue:null
    };
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    explanation: {
      type: String,
      default: null,
    },
    //expiration: {
    //  type: String,
    //  default: null
    //},
    imageUrl: {
      type: String,
      default: null,
    },
    lottieUrl: {
      type: String,
      default: null,
    },
    lottieLoop: {
      type: Boolean,
      default: true,
    },
    details: {
      type: String,
      default: null,
    },
    cancelIsPossible: {
      type: Boolean,
      default: true,
    },
    confirmButtonText: {
      type: String,
      default: null,
    },
    confirmButtonColor: {
      type: String,
      default: 'primary',
    },
    cancelButtonText: {
      type: String,
      default: null,
    },
    isTextDialogOpen: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: null,
    },
    
    pathInfos: {
      type: Object,
      default: null,
    },
    missionsInfos: {
      type: Object,
      default: null,
    },
    accountInfos: {
      type: Object,
      default: null,
    },
    checkListElements: {
      type: Array,
      default: null,
    },
    checkListPreviewMode: {
      type: Boolean,
      default: false,
    },
  },
  
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    pathId() {
      return this.$route.params.pathId;
    },
    pathName() {
      if (!this.pathId) {
        return;
      }
      return this.$store.getters['paths/getPathById'](this.pathId).name[
        this.locale
      ];
    },
    isConfirmButtonDisabled() {
      if (this.type === 'access' && !this.validRestrictionForm) {
        return true;
      }
      return false;
    },
    //expirationToDate() {
    //  var d = new Date();
    //  if (this.expiration) {
    //    d.setUTCSeconds(this.expiration);
    //  }
    //  return d;
    //},
    
    validDeleteValue() {
      console.log('check delete value', this.deleteValue, this.deleteValue === this.deleteText[this.locale])
      return this.deleteValue === this.deleteText[this.locale]
    }
  },
  methods: {
    cancel() {
      if (this.type === 'publishIncompleteChecklist') {
        console.log('cancel checklist');
        this.$emit('cancel-checklist');
      } else {
        this.$emit('cancel');
      }
    },
    confirm() {
      console.log(
        'text dialog confirm',
        this.type
      );
      
       if (this.type === 'deletePath' && this.validDeleteValue) {
        this.$emit('delete-path');
        this.deleteValue = null
      } else if (this.type === 'deleteMission' && this.validDeleteValue) {
        console.log('delete-mission')
        this.$emit('delete-mission');
        this.deleteValue = null
      } else if (
        this.type === 'publish' ||
        this.type === 'publishIncompleteChecklist'
      ) {
        this.$emit('publish-path');
      } else if (this.type === 'deleteLang') {
        this.$emit('delete-lang');
      } else if (this.type === 'unpublish') {
        this.$emit('unpublish-lang');
      } else if (this.type === 'askValidation') {
        this.$emit('askValidation');
      } else if (this.type === 'published') {
        this.$emit('cancel');
      } else if (this.type === 'freeCredit') {
        this.$emit('confirm-free-credit');
      } else {
        this.$emit('confirm');
      }
    },
  },
};
</script>

<style lang="sass">

@import '../assets/_vars.scss'
.restrictionForm__type
  margin-top: 0px;
  margin-bottom: 15px;
  height: 64px;

.restrictionForm__type .v-input--selection-controls__input
  display: none !important

.v-input--selection-controls
  margin-top: 0px

.restrictionForm__icon
  width: 80px
  height: 80px
  border: 1px solid $secondary
  border-radius: 4px
  display: flex
  justify-content: center
  margin: 0em 2em 0em 2em
  i
    color: $secondary !important
.restrictionForm__icon--selected
  background: $primary

.restrictionTypeLabel
  margin: 0.3em 2em 1em 3.5em
  font-size: 10px
  line-height: 15px
  color: $secondary
</style>
